export default {
  isAuthenticated: state => state.token ? true : false,
  authStatus: state => state.status,
  getToken: state => state.token,
  getMenus: state => state.menus,
  getLoading: state => state.loading,
  getUsuario: state => state.user
}


// WEBPACK FOOTER //
// ./src/views/Login/_store/getters.js